import Template from "../../component/Template.js";
import { useEffect, useRef } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import Select from "react-select";

// import 'datatables.net';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import $ from 'jquery';

import Loader from "../../component/Loader.js";
import DownloadLoader from "../../component/DownloadLoader.js";
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function DownloadSupplementaryFacingSheet() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  // const tableRef = useRef(null);
  const [getexamData, setExamData] = useState([]);
  const [examid, setExamIdData] = useState(null);
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState([]);
  const [selectedCourseData, setSelectedCourseData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [loading, setlodaing] = useState(false);
  const [loader, setLoader] = useState(1);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplinedata, setDisciplineData] = useState([]);

  const [totalstudents, setTotal] = useState(0);

  const [activeEventData, setActiveEventData] = useState([]);

  const { http } = Api();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(
          `/College/getActiveExamForFacingSheetSupply`,
          {
            params: {
              event_id: 16,
            },
          }
        );
        setExamData(response.data.activeexam);
      } catch (error) {
        if (
          error.response.data.http_status === 403 &&
          error.response.data.status_code == "ERR37"
        ) {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        } else if (
          error.response.data.http_status === 429 &&
          error.response.data.status_code == "ERR33"
        ) {
          toast.error(error.response.data.message);
        } else if (
          error.response.data.http_status === 500 &&
          error.response.data.status_code == "ERR5"
        ) {
          toast.error("No active exam found");
        } else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  const handlExamChange = (selectedOption) => {
    setExamIdData(selectedOption.value);
    setDisciplineData([]);
    setTableData([]);
  };

  useEffect(() => {
    const fetchDisciplineData = () => {
      http
        .get(`/College/getCollegeOptedDisciplinesSupply`, {
          params: {
            examid: examid,
          },
        })
        .then((response) => {
          setDisciplineData(response.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (
              error.response.data.http_status === 403 &&
              error.response.data.status_code === "ERR37"
            ) {
              toast.error("Invalid Token");
              setTimeout(() => {
                navigate("/college/");
              }, 5000);
            } else if (
              error.response.data.http_status === 429 &&
              error.response.data.status_code === "ERR33"
            ) {
              toast.error(error.response.data.message);
            } else {
              toast.error(error.response.data.message);
            }
          }
        });
    };
    if (examid) {
      fetchDisciplineData();
    }
  }, [examid]);

  /* useEffect(() => {
        const fetchCourses = () => {
            http.get('/College/getCollegeDisciplineCourses', {
                params: {
                    discipline_id: disciplineId,
                    college_course_type: disciplinetype,
                    examid: examid
                },
            })
                .then((response) => {
                    setCourses(response.data || []); // Update course options
                })
                .catch((error) => {
                    console.error("Error fetching courses:", error);
                    setCourses([]); // Clear courses on error
                });
        };

        if (disciplineId && disciplinetype) {
            fetchCourses();
        }
    }, [disciplineId, disciplinetype]); */

  const handleDisciplineChange = (selectedOption) => {
    const newDisciplineId = selectedOption.did;
    const newDisciplineType = selectedOption.type;
    setDisciplineChange(newDisciplineId);
    setDisciplineTypeChange(newDisciplineType);

    setTableData([]);
    setCourses([]);
  };

  useEffect(() => {
    const fetchCourses = () => {
      http
        .get("/College/getCollegeDisciplineCoursesSupply", {
          params: {
            discipline_id: disciplineId,
            college_course_type: disciplinetype,
            examid: examid,
          },
        })
        .then((response) => {
          setCourses(response.data || []); // Update course options
        })
        .catch((error) => {
          console.error("Error fetching courses:", error);
          setCourses([]); // Clear courses on error
        });
    };

    if (disciplineId && disciplinetype) {
      fetchCourses();
    }
  }, [disciplineId, disciplinetype]);

  const handleCourseChange = (selectedOption) => {
    setSelectedCourseData(selectedOption);
    setSelectedCourseId(selectedOption.value);
  };

  useEffect(() => {
    const downloadSupplementaryFacingSheetStudentList = () => {
      http
        .get("/College/downloadFacingSheetSupplymentary", {
          params: {
            examid: examid,
            discipline_id: disciplineId,
            courseid: selectedCourseId,
            college_course_type: disciplinetype,
            event_id: 16,
          },
        })
        .then((response) => {
          const studentCount = response.data.result.length;
          setTotal(studentCount);
          setTableData(response.data.result);
        })
        .catch((error) => {
          console.error("Error fetching Data:", error);
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          // ✅ Clear previous data on error
          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            setTableData([]); // ← use [] instead of null
            setTotal(0);
            toast.error(message || "No students found");
          } else if (
            status === 403 &&
            error.response?.data?.status_code === "ERR37"
          ) {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };

    if (selectedCourseData != "") {
      downloadSupplementaryFacingSheetStudentList();
    }
  }, [selectedCourseData]);

  // useEffect(() => {
  //     const $dataTable = $("#dataTable");

  //     if (tableData.length > 0) {
  //         // Check if the DataTable already exists, and destroy it if so
  //         if ($.fn.DataTable.isDataTable($dataTable)) {
  //             $dataTable.DataTable().clear().destroy();
  //         }

  //         // Ensure the table DOM is present, and only reinitialize the DataTable if it's available
  //         setTimeout(() => {
  //             if ($dataTable.length) {
  //                 $dataTable.DataTable({
  //                     searching: true,
  //                     info: true,
  //                     pageLength: 50,
  //                     autoWidth: false,
  //                     responsive: true,
  //                     columnDefs: [{ targets: "_all", className: "dt-center" }],
  //                 });
  //             }
  //         }, 0); // Delay ensures DOM updates before re-initialization
  //     } else {
  //         // In case tableData is empty, destroy DataTable if it exists
  //         if ($.fn.DataTable.isDataTable($dataTable)) {
  //             $dataTable.DataTable().clear().destroy();
  //         }
  //     }
  // }, [tableData, loading]); // Re-run whenever tableData or loading changes

  const handleGenerateSinglePDF = async (accountid, studentname) => {
    setlodaing(true);
    setLoader(1);

    try {
      const response = await http.get("/College/CollegeStudentFacingsheetPdfSupply", {
        params: {
          examid: examid,
          college_course_type: disciplinetype,
          courseid: selectedCourseId,
          accountid: accountid,
          total_count: 1,
          event_id: 16,
        },
        responseType: "blob", // ✅ Correctly placed inside the same object
      });

      if (response && response.data) {
        setlodaing(false);

        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        ); // ✅ Ensure correct MIME type
        const link = document.createElement("a");
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          "download",
          `${localStorage.getItem(
            "username"
          )}_${studentname}_SupplementaryFacingSheet.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        return Promise.resolve("PDF generated successfully");
      }
    } catch (error) {
      setlodaing(false);
      if (
        error.response.data.http_status === 401 &&
        error.response.data.status_code == "ERR9"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      } else if (
        error.response.status === 403 ||
        error.response.data.status_code == "ERR37"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      } else if (
        error.response.data.http_status === 500 &&
        error.response.data.status_code == "ERR47"
      ) {
        toast.error(error.response.data.message);
      } else {
        console.error("Error generating PDF:", error);
        toast.error("Error generating PDF");
      }
    }
  };

  const handleGenerateBundlePDF = async () => {
    let username = localStorage.getItem("username");

    setlodaing(true);
    setLoader(2);
    try {
      const response = await http.get("/College/CollegeStudentFacingsheetPdfSupply", {
        params: {
          examid: examid,
          college_course_type: disciplinetype,
          courseid: selectedCourseId,
          event_id: 16,
          total_count: totalstudents,
        },
        responseType: "blob",
      });

      if (totalstudents && totalstudents <= 400) {
        if (response && response.data) {
          // Create a URL for the downloaded file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Set the file name and download the PDF
          link.setAttribute(
            "download",
            `${username}_StudentSupplementaryFacingsheet.pdf`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setlodaing(false);
          toast.success("PDF generated successfully");
        }
      } else if (totalstudents && totalstudents > 400) {
        if (response && response.data) {
          // Create a URL for the downloaded ZIP file
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );

          // Create a download link element
          const link = document.createElement("a");
          link.href = url;

          // Set the filename dynamically
          link.setAttribute(
            "download",
            `${username}_StudentSupplementaryFacingsheet.zip`
          );

          // Append the link to the body and trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up: Remove the link and revoke the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          setlodaing(false);
          toast.success("ZIP file downloaded successfully");
        }
      }
    } catch (error) {
      setlodaing(false);
      if (
        error.response.data.http_status === 401 &&
        error.response.data.status_code == "ERR9"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      } else if (
        error.response.status === 403 ||
        error.response.data.status_code == "ERR37"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college");
        }, 5000);
      } else if (
        error.response.data.http_status === 500 &&
        error.response.data.status_code == "ERR47"
      ) {
        toast.error(error.response.data.message);
      } else {
        console.error("Error generating PDF:", error);
        toast.error("Error generating PDF");
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <>{loader === 1 ? <Loader /> : <DownloadLoader />}</>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>
                          Download Supplementary Answer Script Facing Sheet
                        </h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div class="table-container"></div>
                        <div className="table-responsive">
                          <div className="form theme-form">
                            <div className="card-body custom-input">
                              <div className="row">
                                <div className="col-md-4">
                                  <label>
                                    Exam <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    styles={customStyles}
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="exam_id"
                                    name="exam_id"
                                    className="basic-select"
                                    classNamePrefix="select"
                                    options={getexamData.map((exam) => ({
                                      value: exam.examid,
                                      label: exam.examtitle,
                                    }))}
                                    onChange={handlExamChange}
                                    placeholder="Select an exam..."
                                    value={
                                      getexamData
                                        .filter(
                                          (exam) => exam.examid === examid
                                        )
                                        .map((exam) => ({
                                          value: exam.examid,
                                          label: exam.examtitle,
                                        }))[0]
                                    }
                                  />
                                </div>

                                <div className="col-md-4">
                                  <label>
                                    Course Discipline{" "}
                                    <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                  
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    styles={disciplineStyles}
                                    onChange={handleDisciplineChange}
                                    options={
                                      disciplinedata.length > 0
                                        ? disciplinedata
                                            .sort((a, b) =>
                                              a.discipline_name.localeCompare(
                                                b.discipline_name
                                              )
                                            )
                                            .map((discipline) => ({
                                              did: discipline.id,
                                              value: discipline.discipline_name,
                                              label: `${discipline.discipline_name}`, // Combine discipline_name and college_course_type
                                              type: discipline.college_course_type,
                                            }))
                                        : [
                                            {
                                              value: "0",
                                              label: "No data found",
                                            },
                                          ]
                                    }
                                    value={
                                      disciplinedata &&
                                      Array.isArray(disciplinedata)
                                        ? disciplinedata
                                            .filter(
                                              (discipline) =>
                                                discipline.id == disciplineId &&
                                                discipline.college_course_type ==
                                                  disciplinetype // Added filter for discipline_type
                                            )
                                            .map((discipline) => ({
                                              value: discipline.discipline_name,
                                              label: `${discipline.discipline_name}`, // Ensure the selected label matches the dropdown
                                            }))
                                        : [
                                            {
                                              value: "0",
                                              label: "No data found",
                                            },
                                          ]
                                    }
                                  />
                                </div>

                                <div className="col-md-4">
                                  <label>
                                    Course <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    styles={customStyles}
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="course_id"
                                    name="course_id"
                                    className="basic-select"
                                    classNamePrefix="select"
                                    options={
                                      courses.length > 0
                                        ? courses.map((course) => ({
                                            value: course.courseid,
                                            label: course.course_name,
                                          }))
                                        : []
                                    }
                                    onChange={handleCourseChange}
                                    value={
                                      courses.find(
                                        (course) =>
                                          course.courseid === selectedCourseId
                                      )
                                        ? {
                                            value: selectedCourseId,
                                            label: courses.find(
                                              (course) =>
                                                course.courseid ===
                                                selectedCourseId
                                            )?.course_name,
                                          }
                                        : null
                                    }
                                    placeholder="Select a course..."
                                  />
                                </div>
                              </div>

                              <div className="buttons-container dwn-btn-pos">
                                {tableData.length > 0 && (
                                  <button
                                    className="lbl2 btn btn-primary m-r-10"
                                    onClick={handleGenerateBundlePDF}
                                    title="Download"
                                  >
                                    <i class="bi bi-arrow-down-square"></i>
                                  </button>
                                )}
                              </div>

                              <div class="table-responsive">
                                <table
                                  className="table table-striped table-strip-bod "
                                  id="dataTable"
                                  style={{ marginBottom: "50px" }}
                                >
                                  <thead className="table-primary">
                                    <tr
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <th
                                        scope="col"
                                        width="8%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Sl No.
                                      </th>
                                      <th
                                        scope="col"
                                        width="20%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        APAAR No.
                                      </th>
                                      <th
                                        scope="col"
                                        width="20%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        PRN
                                      </th>
                                      <th
                                        scope="col"
                                        width="20%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Name
                                      </th>
                                      <th
                                        scope="col"
                                        width="12%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {tableData.length > 0 ? (
                                      tableData.map((row, index) => (
                                        <tr key={index}>
                                          <td className="txt-aln">
                                            {index + 1}
                                          </td>
                                          <td className="txt-aln">
                                            {row.apaar_no}
                                          </td>{" "}
                                          {/* Replace 'column1' with actual response keys */}
                                          <td className="txt-aln">{row.PRN}</td>{" "}
                                          {/* Replace 'column1' with actual response keys */}
                                          <td className="txt-aln">
                                            {row.studentname}
                                          </td>
                                          <td data-label="Nominal Roll">
                                            <div
                                              className="txt-aln"
                                              style={{ cursor: "pointer" }}
                                            >
                                              <i
                                                className="fa fa-print icn-out-bod"
                                                aria-hidden="true"
                                                title="Download"
                                                onClick={() =>
                                                  handleGenerateSinglePDF(
                                                    row.accountid,
                                                    row.studentname
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="txt-aln">
                                          No data available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
